"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var react_1 = __importStar(require("react"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var tags_ga_1 = require("../../utils/tags-ga");
var menu_item_hook_1 = require("./context/menu-item.hook");
var styles_1 = require("./styles");
/**
 * @deprecated
 * Utilizar agora os componentes MenuItemAccordion e MenuItemIcone
 */
var MenuItem = function (_a) {
    var gaCategory = _a.gaCategory, gaAction = _a.gaAction, gaLabel = _a.gaLabel, eventType = _a.eventType, id = _a.id, icone = _a.icone, titulo = _a.titulo, conteudo = _a.conteudo, bottom = _a.bottom, ariaLabel = _a.ariaLabel, ariaHaspopup = _a.ariaHaspopup, dataTestId = _a.dataTestId, showMargin = _a.showMargin, onClick = _a.onClick, props = __rest(_a, ["gaCategory", "gaAction", "gaLabel", "eventType", "id", "icone", "titulo", "conteudo", "bottom", "ariaLabel", "ariaHaspopup", "dataTestId", "showMargin", "onClick"]);
    var theme = (0, temas_frontend_1.useTheme)().theme;
    var _b = (0, menu_item_hook_1.useMenuItem)(), selected = _b.selected, changeSelected = _b.changeSelected;
    var _c = (0, react_1.useState)(false), showMenuItem = _c[0], setShowMenuItem = _c[1];
    var tituloFormatado = titulo.toLowerCase().replace(' ', '-');
    (0, react_1.useEffect)(function () {
        if (selected === tituloFormatado) {
            setShowMenuItem(true);
        }
        else {
            setShowMenuItem(false);
        }
    }, [selected, tituloFormatado]);
    var onMouseEnterLeaveHandler = function (showHidden) {
        setShowMenuItem(showHidden);
        changeSelected(tituloFormatado);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(tags_ga_1.TagsGa, { category: gaCategory, action: gaAction, label: gaLabel, eventType: eventType },
            react_1.default.createElement(styles_1.MenuItemSectionStyled, __assign({}, props, { "aria-haspopup": ariaHaspopup, "data-testid": dataTestId, showMargin: showMargin, bottom: bottom, onClick: onClick, onMouseEnter: function () { return onMouseEnterLeaveHandler(true); }, onMouseLeave: function () { return onMouseEnterLeaveHandler(false); }, className: "".concat(conteudo != null && 'noSpace', " ").concat(showMenuItem && 'active', "  ").concat(showMenuItem && conteudo != null && 'activeOnly') }),
                react_1.default.createElement(styles_1.MenuItemTitleStyled, { bottom: bottom, id: id, className: "".concat(showMenuItem && 'active', " ").concat(showMenuItem && conteudo != null && 'activeOnly') },
                    react_1.default.createElement(styles_1.MenuItemButtonIconStyled, { "aria-label": ariaLabel, role: "button", onFocus: function () { return onMouseEnterLeaveHandler(true); }, onBlur: function () { return !conteudo && onMouseEnterLeaveHandler(false); } }, icone),
                    showMenuItem && (react_1.default.createElement(styles_1.MenuItemWrapperFirstLevelStyled, null,
                        react_1.default.createElement(paragraphy_styles_1.PStyled, { p16: true, color: theme.black }, titulo)))),
                showMenuItem && conteudo && (react_1.default.createElement(styles_1.MenuItemWrapperStyled, { bottom: bottom, className: conteudo && 'float' },
                    react_1.default.createElement(styles_1.MenuItemContentStyled, { bottom: bottom }, conteudo),
                    bottom && react_1.default.createElement(styles_1.MenuItemInvisibleWrapperStyled, null)))))));
};
exports.MenuItem = MenuItem;
